import { render, staticRenderFns } from "./create_blood_test.vue?vue&type=template&id=8af25dac&"
import script from "./create_blood_test.vue?vue&type=script&lang=js&"
export * from "./create_blood_test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports